import styled from "styled-components";

export const CardTimer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.7rem;
  align-items: center;
  justify-content: center;

  div {
    background: #292828;
    width: 25px;
    height: 25px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 17px;
      height: 17px;

      path {
        stroke: var(--white);
      }
    }
  }

  p {
    font-size: 15px;
    white-space: nowrap;
  }

  .animated {
    svg {
      animation: rotate 3s infinite linear;
      animation-delay: -1s;
    }
  }
`;

export const DayTimer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100% !important;
  background-color: var(--red) !important;
  border-radius: 4px;
  padding: 0rem 0.7rem;

  > svg {
    width: 18px;
    height: 18px;
    margin-left: 8px;
    animation: none;

    path {
      stroke: white;
    }
  }

  cursor: pointer;

  > p {
    font-family: DM Sans, sans-serif;
  }
`;
